import React, { Component } from 'react'
import arrowRight from '../img/right-arrow.svg'
import arrowLeft from '../img/left-arrow.svg'
import { FaTelegramPlane } from "react-icons/fa"
import {IoLogoGoogle} from 'react-icons/io'
import {MdMail, MdPhoneAndroid} from "react-icons/md"


export default class Contact extends Component {
  
    render() {
        return (
            <div className="contact">
                <div className="title">
                    <div className="title__img">
                        <img src={arrowLeft} height="25px" alt="arrow right"/>
                    </div>
                    <div className="title__heading">
                        <h1>Contact info</h1>
                    </div>
                    <div className="title__img">
                        <img src={arrowRight} height="25px" alt="arrow right"/>
                    </div>
                </div>
                <div className="contact-content">
                    <div className="contact-content__info">
                        <h3 className="contact-content__heading">Contact me</h3>
                        <p className="contact-content__text">
                            Please, feel free to leave a message to me. 
                            I would be happy to communicate with you. Also 
                            you can send the messages to my social networks or call me.
                            <br/> Best regards,
                        </p>
                        <span className="contact-content__signature">Karimov Jamshid</span>
                    </div>
                    <div className="contact-content__form">
                        <form className="contact-form" action="">
                            <input className="contact-form__name" type="text" placeholder="Name"/>
                            <input className="contact-form__mail" type="email" placeholder="Email"/>
                            <input className="contact-form__topic" type="text" placeholder="Topic"/>
                            <textarea className="contact-form__textarea" placeholder="Your message" name="text" cols="100%" rows="100%"></textarea>
                            
                            <button className="contact-form__btn">Send message</button>
                        </form>
                    </div>
                    <div className="contact-social">
                        <div className="contact-social__item">
                            <IoLogoGoogle className="contact-social__icon"/>
                            <span className="contact-social__name">jamshid1997karimov@gmail.com</span>
                        </div>
                        <div className="contact-social__item">
                            <FaTelegramPlane className="contact-social__icon"/>
                            <span className="contact-social__name">https://t.me/Karimov_Jamshid</span>
                        </div>
                        <div className="contact-social__item">
                            <MdMail className="contact-social__icon"/>
                            <span className="contact-social__name">jamshid97karimov@mail.ru</span>
                        </div>
                        <div className="contact-social__item">
                            <MdPhoneAndroid className="contact-social__icon"/>
                            <span className="contact-social__name">+998 97 447 01 34</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
